import React, { useEffect, useRef } from "react";

const AnimatedSection = ({ id, children, className = '', delay = 0 }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id={id}
      ref={sectionRef}
      className={`scroll-mt-16 opacity-0 transform translate-y-8 transition-all duration-700 ease-out ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}

      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

        :root {
        --primary-font: 'Montserrat', sans-serif;
        }

        body {
        font-family: var(--primary-font);
        }

        @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
        }

        .animate-fade-in {
        animation: fadeIn 0.8s ease-out forwards;
        }

        .animate-in {
        opacity: 1 !important;
        transform: translateY(0) !important;
        }

        /* Smooth section transitions */
        section {
        transition: transform 0.6s ease-out, opacity 0.6s ease-out;
        }

        /* Custom scrollbar */
        ::-webkit-scrollbar {
        width: 8px;
        }

        ::-webkit-scrollbar-track {
        background: #f1f1f1;
        }

        ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
        background: #666;
        }

        @keyframes spinSlow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .animate-spin-slow {
          animation: spinSlow 12s linear infinite;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-in,
          .animate-fade-in,
          .animate-spin-slow {
            transition: none !important;
            animation: none !important;
          }
        }
    `}</style>

    </section>
  );
};

export default AnimatedSection